import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1,
    backgroundColor: theme.kooee.backgrounds.secondary
  },
  banner: {
    width: "100%"
  },
  bannerText: {
    position: "absolute",
    [theme.breakpoints.up("md")]: {
      top: "50%"
    },
    [theme.breakpoints.down("md")]: {
      top: "40vmin",
      fontSize: "2rem"
    },
    [theme.breakpoints.only("md")]: {
      fontSize: "5rem"
    },
    left: "50%",
    transform: "translate(-50%, -50%)"
  },
  picture: {
    backgroundColor: theme.kooee.backgrounds.secondary
  }
}));
